import React, {useEffect, useState} from 'react'
import {Link} from "react-router-dom";
import './Navbar.css';
import {SidebarData} from "./SidebarData";
import logodanai from "../../../assets/img/logo_danai.svg";
import danaiWhite from "../../../assets/img/logo_danaiWhite.svg";
import infoTkb from "../../../assets/img/icon/icon-info-tkb.svg";
import {postDanai} from "../../util/ajax";

import {Dialog} from 'primereact/dialog';
import Slider from "react-slick";
import moment from 'moment';

function Navbar() {
    const [visible, setVisible] = useState(false);
    const [sidebar, setSidebar] = useState(false)
    const [tkpLancar, setTkpLancar] = useState("-")
    const [tkpDpk, setTkpDpk] = useState("-")
    const [tkpKurangLancar, setTkpKurangLancar] = useState("-")
    const [tkpDiragukan, setTkpDiragukan] = useState("-")
    const [tkpMacet, setTkpMacet] = useState("-")
    const [historyTkpDate, setHistoryTkpDate] = useState("-")
    let settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,

        appendDots: dots => (
        <div className="dots-wrapper">
            <ul className="dots">
                {dots}
            </ul>
        </div>
        ),
    };

    const formatDecimal = (value) =>
    Number(value).toLocaleString('id-ID', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/statistic', function (resp) {
            setTkpLancar(formatDecimal(resp.tkpLancar));
            setTkpDpk(formatDecimal(resp.tkpDpk));
            setTkpKurangLancar(formatDecimal(resp.tkpKurangLancar));
            setTkpDiragukan(formatDecimal(resp.tkpDiragukan));
            setTkpMacet(formatDecimal(resp.tkpMacet));
            setHistoryTkpDate(moment(resp.historyTkpDate, "YYYY-MM-DD").format("DD MMMM YYYY"));
            console.log(resp);
        }, function () {

        });
    }, []);

    const showSidebar = () => setSidebar(!sidebar)
    return (
        <>
            <header className="page-header background-added justify-between" style={{padding: '15px 36px 10px'}}>
                <div className="flex flex-row space-x-5">
                    <a href="/" className="ui-link ui-widget page-header-logo">
                        <picture>
                            <img src={logodanai} alt="Danai.id by PT AdiWisista"/>
                        </picture>
                    </a>
                    {/*<a href="/" className="ui-link ui-widget page-header-logo" style={{alignSelf: 'center'}}>*/}
                    {/*    <picture>*/}
                    {/*        <img src={LogoOjk} alt="OJK"/>*/}
                    {/*    </picture>*/}
                    {/*</a>*/}
                </div>
                <div className="sign-in-and-register" style={{
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'right',
                    gap: '1em',
                    backgroundColor: 'transparent'
                }}>
                    {/* <div className="flex flex-row space-x-5">
                        <a href={linkLogin} className="link-as-outline-button my-2.5 w-32">
                            Masuk
                        </a>
                        <a href={linkLogin} className="link-as-button my-2.5 w-32">
                            Daftar
                        </a>
                    </div> */}
                    <div className="tkb-link">
                        <div className="tanggal-update-tooltip">
                            Terakhir Diperbaharui {historyTkpDate}
                        </div>
                        <div className="container-tkb" onClick={() => setVisible(true)}>
                            <Slider {...settings}>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Lancar</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpLancar}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Dalam Perhatian Khusus</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpDpk}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Kurang Lancar</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpKurangLancar}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Diragukan</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpDiragukan}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Macet</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpMacet}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                        <Dialog modal="true" closable="false" position="center center" resizable="false"
                                draggable="false" responsive="true" showEffect="fade" visible={visible}
                                className="w-[90vw] md:w-[60vw]" onHide={() => {
                            if (!visible) return;
                            setVisible(false);
                        }}>
                            {/* <div className="info-tkb">
                                <div className="header-tkb">
                                    <p className="title">Info TKB</p>
                                </div>
                                <div className="container-info-tkb">
                                    <ol className="list-disc">
                                        <li>
                                            <b>TKB90</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            pendanaan dalam jangka waktu sampai dengan 90 (sembilan puluh) hari
                                            kalender terhitung sejak jatuh tempo.
                                        </li>
                                        <li>
                                            <b>TKB60</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            pendanaan dalam jangka waktu sampai dengan 60 (enam puluh) hari
                                            kalender terhitung sejak jatuh tempo.
                                        </li>
                                        <li>
                                            <b>TKB30</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            pendanaan dalam jangka waktu sampai dengan 30 (tiga puluh) hari
                                            kalender terhitung sejak jatuh tempo.
                                        </li>
                                        <li>
                                            <b>TKB0</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            pendanaan dalam jangka waktu sampai dengan 0 (nol) hari kalender
                                            terhitung sejak jatuh tempo.
                                        </li>
                                    </ol>
                                </div>
                            </div> */}
                            <div className="info-tkb">
                                <div className="header-tkb">
                                    <p className="title">Tingkatan Kualitas Pendanaan (TKP)</p>
                                </div>
                                <div className="container-info-tkb">
                                    <ol className="list-disc">
                                        <li>
                                            <b>Lancar</b> adalah tingkat kualitas Pendanaan apabila tidak terdapat 
                                            keterlambatan pembayaran pokok dan/atau manfaat ekonomi Pendanaan.
                                        </li>
                                        <li>
                                            <b>Dalam Perhatian Khusus (DPK)</b> adalah tingkat kualitas Pendanaan 
                                            apabila terdapat keterlambatan pembayaran pokok dan/atau manfaat ekonomi 
                                            Pendanaan yang telah melampaui jatuh tempo sampai dengan 30 (tiga puluh) hari kalender.
                                        </li>
                                        <li>
                                            <b>Kurang Lancar</b> adalah tingkat kualitas Pendanaan apabila terdapat 
                                            keterlambatan pembayaran pokok dan/atau manfaat ekonomi Pendanaan yang telah 
                                            melampaui jatuh tempo 30 (tiga puluh) hari kalender sampai dengan 60 (enam puluh) hari kalender.
                                        </li>
                                        <li>
                                            <b>Diragukan</b> adalah tingkat kualitas Pendanaan apabila terdapat keterlambatan 
                                            pembayaran pokok dan/atau manfaat ekonomi Pendanaan yang telah melampaui jatuh 
                                            tempo 60 (enam puluh) hari kalender sampai dengan 90 (sembilan puluh) hari kalender.
                                        </li>
                                        <li>
                                            <b>Macet</b> adalah tingkat kualitas Pendanaan apabila terdapat keterlambatan pembayaran 
                                            pokok dan/atau manfaat ekonomi Pendanaan yang telah melampaui jatuh tempo 90 (sembilan puluh) hari kalender.
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </header>
            <a href={() => false} className={`side-menu-trigger ${sidebar ? "closed" : ""}`} onClick={showSidebar}>
                <span className="menu-hide">Menu</span>
                <span></span>
            </a>
            <aside className={`side-menu ${sidebar ? "shown" : ""}`}>
                <img src={danaiWhite} alt="Danai.id by PT AdiWisista"/>
                <nav>
                    <div className={"space-y-8 py-5 grid grid-cols-2 gap-4"}>
                        {SidebarData.map((item, index) => {
                            return (
                                <div key={index} className={"w-full side-menu-item"} style={{margin: 0}}>
                                    <Link onClick={showSidebar}
                                          className={"navbar-item border-b-2 border-white px-5 rounded-lg my-auto hover:bg-danai-green transition duration-300 h-24 grid justify-center items-center justify-items-center"}
                                          to={item.path} style={{border: "1px solid #A9A9A9"}}>
                                        <img src={item.img} className="w-8" alt="logo"/>
                                        <div className={"text-md my-auto text-white"}>{item.tittle}</div>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                </nav>
                <div className="tkb-link">
                    <div className="container-tkb" onClick={() => setVisible(true)}>
                            <Slider {...settings}>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Lancar</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpLancar}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p style={{fontSize:'12px'}}>Dalam Perhatian Khusus</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpDpk}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Kurang Lancar</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpKurangLancar}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Diragukan</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpDiragukan}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className='text-area'>
                                        <p className='grey'>Kualitas Pendanaan</p>
                                        <p>Macet</p>
                                    </div>
                                    <div className='tkp-icon'>
                                        <p className='blue'>{tkpMacet}%</p>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </div>
                                </div>
                            </Slider>
                    </div>
                    </div>
                <footer>
                    <p>© 2018 - <span className="current-year"></span> <strong>PT Adiwisista</strong>. All rights
                        reserved.</p>
                </footer>
            </aside>
        </>
    );
}

export default Navbar;
